import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-shadow: ", ";\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  width: ", ";\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { color, property } from '@scp/ui-shared/theme/variables';
import { COLUMN_SIZE, LAYOUT_Z_INDEX_MAP } from './constants';
export var sideNavigationHolderBase = css(_templateObject(), color.background, property.boxShadow, COLUMN_SIZE.SIDE_NAV, LAYOUT_Z_INDEX_MAP.NAVIGATION);